<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/web/mixture/bom/page" ref="yt" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" class="demo-form-inline">
          <el-form-item :label="$t('hunliaogongdan')" class="noborder">
            {{ $attrs.materialObj.no }}
          </el-form-item>
        </el-form>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>

  export default {
    name: 'material_list',
    data() {
      return {
        columns: [
          {
            label: 'wuliaobianma',
            prop: 'material.code'
          },
          {
            label: 'wuliaomingcheng',
            prop: 'material.name'
          },
          {
            label: 'guige',
            prop: 'material.spec'
          },
          {
            label: 'shuliang',
            prop: 'quantity'
          },
          {
            label: 'danwei',
            prop: 'unit'
          }
        ]
      }
    },
    created() {
      setTimeout(() => {
        this.yt.conditions = {
          mixtureOrderId: this.$attrs.materialObj.id,
        }
        this.yt.get(1);
      }, 300);
    }
  };
</script>

<style scoped>

</style>